import React, { useEffect, useRef, useState } from "react";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";
import { getDeliveryServices } from "../../api/DeliveryService";

const DeliveryServiceFilter = ({
  selectedValue,
  onFilterChange,
  allowCreation = false,
}) => {
  const loadDataAttempts = useRef(0);
  const [deliveryServices, setDeliveryServices] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  // Update deliveryServices when allowCreation changes
  useEffect(() => {
    if (deliveryServices.length > 0) {
      // Check if "Criar Novo" already exists to prevent duplicate
      const hasCreateNew = deliveryServices.some(
        (service) => service.value === "create_new"
      );

      if (allowCreation && !hasCreateNew) {
        setDeliveryServices([
          ...deliveryServices,
          { label: "Criar Novo", value: "create_new" },
        ]);
      } else if (!allowCreation && hasCreateNew) {
        setDeliveryServices(
          deliveryServices.filter((service) => service.value !== "create_new")
        );
      }
    }
  }, [allowCreation, deliveryServices]);

  const loadData = async () => {
    try {
      const { data } = await getDeliveryServices();

      const delivery_services_treated = data.map((deliveryService) => {
        return {
          label: deliveryService.name,
          value: deliveryService.id,
        };
      });

      setDeliveryServices(
        allowCreation
          ? [
              ...delivery_services_treated,
              { label: "Criar Novo", value: "create_new" },
            ]
          : delivery_services_treated
      );
    } catch (e) {
      console.log(e);
      loadDataAttempts.current += 1;

      if (loadDataAttempts.current < 2) {
        setTimeout(loadData, 100);
      }
    }
  };

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="merchant-values"
      options={deliveryServices}
      value={selectedValue}
      getOptionLabel={(option) => option?.label || ""}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Disk Moto"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

DeliveryServiceFilter.displayName = "Disk Moto";

export default DeliveryServiceFilter;
